<template>
    <div>
        <div class="external-table-actions">
            <div v-if="habilitarSelecionarTodos" class="action check-button">
                <v-checkbox
                    v-model="selecionarTodos"
                    :label="labelSelectAll"
                    color="primary"
                    @change="selectAllItems"
                />
            </div>
        </div>

        <v-data-table
            :headers="headers"
            :items="titulos"
            item-text="titulo"
            v-model="selecionados"
            :options.sync="options"
            :loading="loading"
            :single-select="false"
            item-key="id_titulo"
            show-select
            :footer-props="{
                itemsPerPageOptions: [300, 600, 900],
                itemsPerPageText: 'Itens por página:'
            }"
            :server-items-length="totalTitulos"
            loading-text="Pesquisando títulos..."
            no-data-text="Preencha os filtros e clique em filtrar..."
            no-results-text="Nenhum título encontrado..."
            class="elevation-1 pa-3"
        >
            <template v-slot:[`item.ds_nosso_numero`]="{ item }">
                <span
                    v-if="item.ds_revisao != ''"
                    title="Este título precisa ser revisado. "
                    :style="{ color: 'red' }"
                    >{{ item.ds_nosso_numero }}</span
                >
                <span v-else :style="{ color: 'black' }">{{
                    item.ds_nosso_numero
                }}</span>
            </template>
            <template v-slot:[`item.dt_cadastro`]="{ item }">
                <span
                    v-if="item.ds_revisao != ''"
                    title="Este título precisa ser revisado. "
                    :style="{ color: 'red' }"
                    >{{ item.dt_cadastro }}</span
                >
                <span v-else :style="{ color: 'black' }">{{
                    item.dt_cadastro
                }}</span>
            </template>
            <template v-slot:[`item.nu_identificacao_devedor`]="{ item }">
                <span
                    v-if="item.ds_revisao != ''"
                    title="Este título precisa ser revisado. "
                    :style="{ color: 'red' }"
                    >{{ formatDocumento(item) }}</span
                >
                <span v-else :style="{ color: 'black' }">{{
                    formatDocumento(item)
                }}</span>
            </template>
            <template v-slot:[`item.nm_devedor`]="{ item }">
                <span
                    v-if="item.ds_revisao != ''"
                    title="Este título precisa ser revisado. "
                    :style="{ color: 'red' }"
                    >{{ item.nm_devedor }}</span
                >
                <span v-else :style="{ color: 'black' }">{{
                    item.nm_devedor
                }}</span>
            </template>
            <template v-slot:[`item.vl_saldo_protesto`]="{ item }">
                <span
                    v-if="item.ds_revisao != ''"
                    title="Este título precisa ser revisado. "
                    :style="{ color: 'red' }"
                    >{{ item.vl_saldo_protesto }}</span
                >
                <span v-else :style="{ color: 'black' }">{{
                    item.vl_saldo_protesto
                }}</span>
            </template>
            <template v-slot:[`item.cd_status`]="{ item }">
                <span
                    v-if="item.ds_revisao != ''"
                    title="Este título precisa ser revisado. "
                    :style="{ color: 'red' }"
                    >{{ getDescSituacao(item) }}</span
                >
                <span v-else :style="{ color: 'black' }">{{
                    getDescSituacao(item)
                }}</span>
            </template>
            <template v-slot:[`item.dt_atualizacao`]="{ item }">
                <span
                    v-if="item.ds_revisao != ''"
                    title="Este título precisa ser revisado. "
                    :style="{ color: 'red' }"
                    >{{ item.dt_atualizacao }}</span
                >
                <span v-else :style="{ color: 'black' }">{{
                    item.dt_atualizacao
                }}</span>
            </template>
            <template v-slot:[`item.fl_original`]="{ item }">
                {{
                    item.cd_comprador === null
                        ? ''
                        : `Original: ${item.cd_apresentante}`
                }}
            </template>
        </v-data-table>
        <Snackbar
            v-if="feedbackSnackbar"
            :mostrarSnackbar="feedbackSnackbar"
            :corSnackbar="feedbackSnackbarColor"
            :mensagemSnackbar="mensagemfeedbackSnackbar"
            @fecharSnackbar="feedbackSnackbar = false"
        />
    </div>
</template>
<script>
import * as Formatter from '@/helpers/Formatter';
import Snackbar from '@/components/Snackbar';

export default {
    name: 'TableWithSelectionsCessao',
    components: {
        Snackbar
    },
    props: {
        headers: {
            type: Array,
            required: false,
            default: () => [
                {
                    text: 'Código do título',
                    sortable: true,
                    value: 'ds_nosso_numero'
                },
                {
                    text: 'Data de envio',
                    align: 'left',
                    sortable: true,
                    value: 'dt_cadastro'
                },
                {
                    text: 'CPF/CNPJ',
                    sortable: true,
                    value: 'nu_identificacao_devedor'
                },
                { text: 'Nome', sortable: true, value: 'nm_devedor' },
                {
                    text: 'Valor R$',
                    sortable: true,
                    value: 'vl_saldo_protesto'
                },
                { text: 'Status', sortable: true, value: 'cd_status' },
                {
                    text: 'Data de atualização',
                    align: 'left',
                    sortable: true,
                    value: 'dt_atualizacao'
                },
                { text: 'Original', sortable: true, value: 'fl_original' },
                { text: ' ', sortable: true, value: 'action' }
            ]
        },
        titulos: {
            type: Array,
            required: true
        },
        totalTitulos: {
            type: Number,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            selecionados: [],
            situacoesTitulo: this.$store.getters.situacoesTitulo,
            feedbackSnackbarTimeout: 5000,
            feedbackSnackbarColor: 'red',
            feedbackSnackbar: false,
            mensagemfeedbackSnackbar:
                'Você não pode selecionar mais de 900 títulos',
            options: {
                page: 1,
                itemsPerPage: 300
            },
            habilitarSelecionarTodos: false,
            selecionarTodos: false
        };
    },
    computed: {
        labelSelectAll() {
            return `Selecionar todos os ${this.totalTitulos} títulos`;
        }
    },
    watch: {
        selecionados(val, oldVal) {
            if (val.length > 900) {
                this.feedbackSnackbar = true;
                this.$nextTick(() => {
                    this.selecionados = oldVal;
                });
            }

            if (this.titulos.length > 0) {
                if (this.selecionados.length != this.titulos.length) {
                    this.selecionarTodos = false;
                    this.$emit('selecionarTodos', this.selecionarTodos);
                }
                this.habilitarSelecionarTodos =
                    this.selecionados.length == this.titulos.length;
            }

            this.$emit('selecionados', val);
        },
        options(val) {
            this.$emit('changeOptionsPage', val);
        }
    },
    methods: {
        resetSelecionados() {
            this.selecionados = [];
        },
        formatDocumento(titulo) {
            return Formatter.formatDocumento(
                titulo.nu_identificacao_devedor,
                titulo.tp_identificacao_devedor
            );
        },
        getDescSituacao(item) {
            const situacao = this.situacoesTitulo.find(
                situacao => situacao.cd_status === item.cd_status
            );
            return situacao ? situacao.nm_status : item.cd_status;
        },
        selectAllItems() {
            this.$emit('selecionarTodos', this.selecionarTodos);
        }
    }
};
</script>

<style scoped lang="scss">
.external-table-actions {
    display: flex;
    justify-content: flex-end;

    .check-button {
        label {
            text-decoration: underline !important;
        }
    }
}
</style>
